"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var IntervalScheduler_1 = require("../scheduler/IntervalScheduler");

var MediaDeviceProxyHandler = /*#__PURE__*/function () {
  function MediaDeviceProxyHandler() {
    var _this = this;

    _classCallCheck(this, MediaDeviceProxyHandler);

    this.scheduler = null;
    this.devices = null;
    this.deviceChangeListeners = new Set(); // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types

    this.get = function (target, property, receiver) {
      if (!Reflect.has(target, property)) {
        return undefined;
      }

      if (!('ondevicechange' in navigator.mediaDevices)) {
        if (property === 'addEventListener') {
          return _this.patchAddEventListener(target, property, receiver);
        } else if (property === 'removeEventListener') {
          return _this.patchRemoveEventListener(target, property, receiver);
        }
      }

      var value = Reflect.get(target, property, receiver);
      return typeof value === 'function' ? value.bind(target) : value;
    };

    this.patchAddEventListener = function (target, property, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    receiver) {
      var value = Reflect.get(target, property, receiver);
      return function (type, listener, options) {
        if (type === 'devicechange') {
          _this.deviceChangeListeners.add(listener);

          if (!_this.scheduler) {
            _this.scheduler = new IntervalScheduler_1.default(MediaDeviceProxyHandler.INTERVAL_MS);

            _this.scheduler.start(_this.pollDeviceLists);
          }
        } else {
          return Reflect.apply(value, target, [type, listener, options]);
        }
      };
    };

    this.patchRemoveEventListener = function (target, property, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    receiver) {
      var value = Reflect.get(target, property, receiver);
      return function (type, listener, options) {
        if (type === 'devicechange') {
          _this.deviceChangeListeners.delete(listener);

          if (_this.deviceChangeListeners.size === 0 && _this.scheduler) {
            _this.scheduler.stop();

            _this.scheduler = null;
          }
        } else {
          return Reflect.apply(value, target, [type, listener, options]);
        }
      };
    };

    this.pollDeviceLists = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var newDevices, changed;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.sortedDeviceList();

              case 2:
                newDevices = _context.sent;

                if (this.devices) {
                  changed = newDevices.length !== this.devices.length || newDevices.some(function (device, index) {
                    return device.deviceId !== _this2.devices[index].deviceId;
                  });

                  if (changed) {
                    this.handleDeviceChangeEvent();
                  }
                }

                this.devices = newDevices;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
  }

  _createClass(MediaDeviceProxyHandler, [{
    key: "sortedDeviceList",
    value: function sortedDeviceList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var newDevices;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return navigator.mediaDevices.enumerateDevices();

              case 2:
                newDevices = _context2.sent;
                return _context2.abrupt("return", newDevices.sort(function (device1, device2) {
                  if (device1.deviceId < device2.deviceId) {
                    return 1;
                  }

                  if (device1.deviceId > device2.deviceId) {
                    return -1;
                  }

                  return 0;
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "handleDeviceChangeEvent",
    value: function handleDeviceChangeEvent() {
      var _this3 = this;

      var _iterator = _createForOfIteratorHelper(this.deviceChangeListeners),
          _step;

      try {
        var _loop = function _loop() {
          var listener = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            /* istanbul ignore else */
            if (_this3.deviceChangeListeners.has(listener)) {
              var event = new Event('devicechange');

              if (typeof listener === 'function') {
                listener(event);
              } else {
                listener.handleEvent(event);
              }
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return MediaDeviceProxyHandler;
}();

exports.default = MediaDeviceProxyHandler;
MediaDeviceProxyHandler.INTERVAL_MS = 1000;